import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/app/config/environments/environment";
import { ContractedFeatureFilterDto } from "../models/dto/contracted-feature-filter.dto";
import { ContractedFeature } from "../models/interfaces/contracted-features.interface";

@Injectable()
export class ContractedFeatureService {
  constructor(private http: HttpClient) {}

  public get(filter: ContractedFeatureFilterDto): Observable<ContractedFeature[]> {
    return this.http.get<ContractedFeature[]>(
      `${environment.api.baseUrl}/contractedfeatures/active/v2`,
      { params: this.buildParams(filter) },
    )
  }

  private buildParams(filter: ContractedFeatureFilterDto): HttpParams {
    let params = new HttpParams();
    params = filter.idUser
      ? params.set('idUser', filter.idUser)
      : params;
    params = filter.idSchool
        ? params.set('idSchool', filter.idSchool)
        : params;
    return params;
  }  
}
